import { render, staticRenderFns } from "./Acceptance.vue?vue&type=template&id=620c8a1c&scoped=true"
import script from "./Acceptance.vue?vue&type=script&lang=js"
export * from "./Acceptance.vue?vue&type=script&lang=js"
import style0 from "./Acceptance.vue?vue&type=style&index=0&id=620c8a1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620c8a1c",
  null
  
)

export default component.exports